export default __webpack_public_path__ + "static/media/amanita4.c0f30b62.png";